export const EmployeeData = [
  {
    id: 1,
    employeeCode: "EMP-001",
    fullName: "Aayush Shrestha",
    designation: "Dispute Officer",
    department: "Customer Support",
    branch: "Kathmandu Central",
    contactNumber: "+977-9801234567",
    email: "aayush.shrestha@dms.com",
    joinDate: "2023-05-14",
    totalDisputesHandled: 56,
    resolvedCases: 50,
    pendingCases: 6,
    status: "Active",
  },
  {
    id: 2,
    employeeCode: "EMP-002",
    fullName: "Sneha Tamang",
    designation: "Legal Advisor",
    department: "Legal Affairs",
    branch: "Lalitpur Office",
    contactNumber: "+977-9812345678",
    email: "sneha.tamang@dms.com",
    joinDate: "2022-12-02",
    totalDisputesHandled: 42,
    resolvedCases: 38,
    pendingCases: 4,
    status: "Active",
  },
  {
    id: 3,
    employeeCode: "EMP-003",
    fullName: "Bishal Gurung",
    designation: "Investigation Analyst",
    department: "Fraud Investigation",
    branch: "Pokhara Lakeside",
    contactNumber: "+977-9823456789",
    email: "bishal.gurung@dms.com",
    joinDate: "2021-10-19",
    totalDisputesHandled: 30,
    resolvedCases: 26,
    pendingCases: 4,
    status: "Active",
  },
  {
    id: 4,
    employeeCode: "EMP-004",
    fullName: "Nisha Adhikari",
    designation: "Audit Officer",
    department: "Finance & Audit",
    branch: "Biratnagar East",
    contactNumber: "+977-9834567890",
    email: "nisha.adhikari@dms.com",
    joinDate: "2020-08-25",
    totalDisputesHandled: 20,
    resolvedCases: 18,
    pendingCases: 2,
    status: "Inactive",
  },
  {
    id: 5,
    employeeCode: "EMP-005",
    fullName: "Rabin KC",
    designation: "Operations Lead",
    department: "Operations",
    branch: "Chitwan Bharatpur",
    contactNumber: "+977-9845678901",
    email: "rabin.kc@dms.com",
    joinDate: "2023-03-07",
    totalDisputesHandled: 15,
    resolvedCases: 12,
    pendingCases: 3,
    status: "Active",
  },
  {
    id: 6,
    employeeCode: "EMP-006",
    fullName: "Sujata Lama",
    designation: "Dispute Analyst",
    department: "Customer Support",
    branch: "Kathmandu Central",
    contactNumber: "+977-9856789012",
    email: "sujata.lama@dms.com",
    joinDate: "2024-01-11",
    totalDisputesHandled: 10,
    resolvedCases: 9,
    pendingCases: 1,
    status: "Active",
  },
]